import { render, staticRenderFns } from "./ys-log-management.vue?vue&type=template&id=20dc67b0&scoped=true"
import script from "./ys-log-management.vue?vue&type=script&lang=js"
export * from "./ys-log-management.vue?vue&type=script&lang=js"
import style0 from "./ys-log-management.vue?vue&type=style&index=0&id=20dc67b0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc67b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20dc67b0')) {
      api.createRecord('20dc67b0', component.options)
    } else {
      api.reload('20dc67b0', component.options)
    }
    module.hot.accept("./ys-log-management.vue?vue&type=template&id=20dc67b0&scoped=true", function () {
      api.rerender('20dc67b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/ys-log-management/ys-log-management.vue"
export default component.exports